import { render, staticRenderFns } from "./tickets-list.vue?vue&type=template&id=91bf0374&"
import script from "./tickets-list.vue?vue&type=script&lang=js&"
export * from "./tickets-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports